import type { FC, ReactNode } from "react";

interface SquareFrameProps {
  className?: string;
  children?: ReactNode;
}

export const SquareFrameAI: FC<SquareFrameProps> = ({
  className = "w-full h-full",
  children,
}) => {
  /**
   * Render an NxN grid of DIVs,
   * border only on row=0, row>=N-2, col=0, col=N-1
   */
  const renderCells = (N: number) =>
    Array.from({ length: N * N }).map((_, idx) => {
      const row = Math.floor(idx / N);
      const col = idx % N;
      const isBorder = row === N - 1;

      return (
        <div
          key={`${N}-${idx}`}
          className={
            isBorder
              ? "border-t-2 border-l border-r border-b border-[#EAEAEA] dark:border-[#1E1E1E]"
              : ""
          }
        />
      );
    });

  return (
    <div className={`relative overflow-hidden ${className}`}>
      <div className="absolute inset-0 grid grid-cols-8 grid-rows-8 sm:hidden pointer-events-none">
        {renderCells(8)}
      </div>

      <div className="absolute inset-0 hidden sm:grid md:hidden grid-cols-8 grid-rows-8 pointer-events-none">
        {renderCells(8)}
      </div>

      <div className="absolute inset-0 hidden md:grid lg:hidden grid-cols-12 grid-rows-12 pointer-events-none">
        {renderCells(12)}
      </div>

      <div className="absolute inset-0 hidden lg:grid grid-cols-12 grid-rows-12 pointer-events-none">
        {renderCells(12)}
      </div>
      {children && (
        <div className="relative z-10 w-full h-full flex items-center justify-center">
          <div className="flex items-center justify-center">{children}</div>
        </div>
      )}
    </div>
  );
};
